import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

export const tableColumns = (handleAction) => [
    { dataField: "id", text: "ID", sort: true, headerStyle: { width: '80px' } },
    {
        dataField: 'image', text: 'Add Image', style: { width: '80px' },
        formatter: function ProfilePicFormatter(cell, row) {
            return (<img src={row.profile_pic || '/images/default-avatar.png'} alt={`${row.first_name}'s profile`}
                style={{ width: '80px', height: '40px', objectFit: 'cover', }}
                onError={(e) => { e.target.onerror = null; e.target.src = 'https://media.istockphoto.com/id/1287566568/photo/every-contribution-adds-up.jpg?s=2048x2048&w=is&k=20&c=8yGPRwKiwubFImEJ-BLIPyzhShhByrvv77901m1CzO8='; }} />);
        },
    },
    { dataField: "ad_title", text: "Add Title", sort: true },
    { dataField: "impressions", text: "Impressions", sort: true },
    { dataField: "clicks", text: "Clicks", sort: true },
    { dataField: "start_date", text: "Start Date", sort: true },
    { dataField: "end_date", text: "End Date", sort: true },
    {
        dataField: "status", text: "Status",
        formatter: (cell) => (
            <span className={`badge rounded-pill ${["Active", "Verified"].includes(cell) ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'
                }`} style={{ fontSize: '11px', padding: '5px 10px' }}>
                {cell}
            </span>
        )
    },
    {
        dataField: "actions", text: "Action", headerClasses: "text-end px-4", classes: "text-end px-4", isDummyField: true,
        formatter: (_, row) => (
            <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm border">
                    <i className="bx bx-dots-horizontal-rounded"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem onClick={() => handleAction("View", row)}>
                        <i className="bx bx-show-alt me-2 text-primary"></i> View
                    </DropdownItem>
                    <DropdownItem onClick={() => handleAction("Edit", row)}>
                        <i className="bx bx-pencil me-2 text-success"></i> Edit
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="text-danger">
                        <i className="bx bx-trash me-2"></i> Delete
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        ),
    },
];